import { render } from "./Ceshi.vue?vue&type=template&id=974d2ea2&scoped=true"
import script from "./Ceshi.vue?vue&type=script&lang=js"
export * from "./Ceshi.vue?vue&type=script&lang=js"

import "./Ceshi.vue?vue&type=style&index=0&id=974d2ea2&scoped=true&lang=css"

import exportComponent from "D:\\hym\\WEB\\交接项目\\盘古信息客户应用案例\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-974d2ea2"]])

export default __exports__